import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import './banner.scss';

import config from '@dom/config';

function Banner({ bannerImages, profileImages, children, match, isViewingOwnProfile }) {
  const { large: largeProfileImage } = profileImages || {};
  return (
    <div className="banner-holder">
      <div className="cover-image">
        { isViewingOwnProfile && <Link to={`${match.url}/edit/basic`} className="btn btn-edit">Edit</Link> }
        <img className="banner-img" src="https://s3.amazonaws.com/honeyguide/assets/profile-bg.jpg" alt="banner" />
      </div>
      <div className="info">
        <div className="profile-image" style={{ backgroundImage: `url(${config.RESOURCE_URL}/${largeProfileImage})` }} >
          {/* TODO: use Image Tag with srcset */}
          {/* <img alt="profile" src="https://apiv2.honeyguideapps.com/static/user/a4d6fc0c92b7_cl.jpeg" /> */}
        </div>
        {children}
      </div>
    </div>
  );
}

const mapStateToProps = ({ user }, { match }) => {
  const { id } = match.params;
  const userId = user.data && user.data.id;

  return {
    isViewingOwnProfile: id === userId,
  }; 
}
const connectedBanner = connect(mapStateToProps)(Banner);

export default withRouter(connectedBanner);
